import { PlayerState } from './player_state';

// Define action types
export type PlayerAction =
  | { type: 'PLAY' }
  | { type: 'PAUSE' }
  | { type: 'TOGGLE_PLAY' }
  | { type: 'DURATION'; payload: number }
  | { type: 'PROGRESS'; payload: number }
  | { type: 'SEEK'; payload: number }
  | { type: 'VOLUME'; payload: number }
  | { type: 'LIGHT'; payload: boolean };

const storedVolume = parseFloat(localStorage.getItem("video_sound") || "0.8");
// Initial state
const INITIAL_STATE: PlayerState = {
  playing: false,
  volume: storedVolume,
  duration: 0,
  progress: {
    playedSeconds: 0,
  },
  light: true,
  controls: false,
  loop: false,
  muted: false,
  playbackRate: 1,
};

// Reducer function
const reducer = (state: PlayerState, action: PlayerAction): PlayerState => {
  switch (action.type) {
    case 'PLAY':
      return { ...state, playing: true };
    case 'PAUSE':
      return { ...state, playing: false };
    case 'TOGGLE_PLAY':
      return { ...state, playing: !state.playing };
    case 'DURATION':
      return { ...state, duration: action.payload };
    case 'PROGRESS':
      return {...state, progress: { playedSeconds: action.payload }};
    case 'SEEK':
      return { ...state, progress: { playedSeconds: action.payload } };
    case 'VOLUME':
      return { ...state, volume: action.payload };
    case 'LIGHT':
      return { ...state, light: action.payload };
    default:
      return state;
  }
};

export { reducer, INITIAL_STATE };
